import { Cart } from "@omni/types/api/cart/bff/cart.model";
import { Just, Maybe, Nothing } from "@omni/utils/maybe.utils";

const requiredProps = [
    "baseStore",
    "billingAddressId",
    "deliveryAddressId",
    "callToActions",
    "cartsMerged",
    "checkoutStep",
    "customerId",
    "items",
    "messages",
    "shopId",
    "subTotalPrice",
    "totalPrice"
];

export const returnMaybeCartModel = (data?: any): Maybe<Cart> => {
    if (!data) {
        return Nothing();
    }

    try {
        return requiredProps.every((p) => p in data)
            ? Just<Cart>(data)
            : Nothing();
    } catch {
        return Nothing();
    }
};
